import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { api, fmtDate, normalizeImageUrl } from "@/lib/api";
import { ArrowLeft } from "lucide-react";

export default function NewsDetail() {
  const { id } = useParams();
  const [n, setN] = useState(null);
  useEffect(() => { api.get(`/news/${id}`).then(r => setN(r.data)); }, [id]);
  if (!n) return <div className="p-10 text-center text-slate-500">Memuat...</div>;
  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 py-16">
      <Link to="/berita" className="inline-flex items-center gap-2 text-emerald-800 hover:text-amber-600 text-sm mb-6"><ArrowLeft className="w-4 h-4" /> Kembali</Link>
      <div className="text-xs font-bold uppercase tracking-widest text-amber-600">{n.category} · {fmtDate(n.date)}</div>
      <h1 className="font-display text-3xl sm:text-4xl font-extrabold text-emerald-950 mt-3 leading-tight">{n.title}</h1>
      <div className="aspect-[16/9] rounded-2xl overflow-hidden mt-8">
        <img src={normalizeImageUrl(n.photo_url)} alt={n.title} className="w-full h-full object-cover" />
      </div>
      <div className="prose prose-slate mt-8 text-slate-700 leading-relaxed whitespace-pre-line">{n.body}</div>
    </div>
  );
}
